module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"name_colon":"Name:","living_donor_id_colon":"Afflo ID:"},"fr":{"name_colon":"Nom :","living_donor_id_colon":"No Afflo :"},"en_tgln":{"living_donor_id_colon":"TGLN ID:"},"fr_tgln":{"living_donor_id_colon":"No TGLN :"},"en_tq":{"living_donor_id_colon":"TQ Number:"},"fr_tq":{"living_donor_id_colon":"No TQ :"}}')
  delete Component.options._Ctor
}
